import clsx from 'clsx';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import Icon from '../../basic/icons';
import { INavbarControllerProps } from './modal';

const NavbarController = (props: INavbarControllerProps): JSX.Element => {
  const { variant, className, positionNavControllers, showFocus } = props;
  const isLeftVariant = variant === 'left';
  const isOnMedia = positionNavControllers === 'onMedia';
  const { t } = useTranslation();
  return (
    <button
      tabIndex={0}
      className={clsx(
        `navbar-controller transform -translate-y-1/2 inset-y-0 flex p-0 text-center border-0 transition h-2md ${isOnMedia && 'w-xs xl:my-3xl h-sm'
        } hover:outline-none hover:no-underline !bg-transparent !opacity-100`,
        {
          'carousel-control-prev': isLeftVariant,
          'carousel-control-next': !isLeftVariant,
          'left-0': isLeftVariant && isOnMedia,
          'right-0': !isLeftVariant && isOnMedia,
          'justify-start': isLeftVariant,
          'justify-end': !isLeftVariant,
          'focus:outline-none focus:no-underline': !showFocus,
          'mt-[25px]': showFocus,
        },
        className
      )}
      data-bs-target={`#${props['target-testid']}`}
      data-bs-slide={isLeftVariant ? 'prev' : 'next'}
      data-testid="nav-controllers"
      onClick={props.onClick}
      aria-label={isLeftVariant ? t('Previous New arrival') || '' : t('Next New arrival') || ''}
    >
      <Icon
        className={clsx('bg-no-repeat absolute lg:top-0 sm:top-0 text-inky text-lg', {
          'carousel-control-prev-icon': isLeftVariant,
          'carousel-control-next-icon': !isLeftVariant,
          '-mt-[12px]': showFocus,
        })}
        aria-hidden="true"
        name={isLeftVariant ? 'leftArrow' : 'rightArrow'}
      />
    </button>
  );
};
export default NavbarController;
